import React, { Component } from 'react';
import Card from '../component/Card'
const Chart = require('chart.js');
class Dashboard extends Component {
    componentDidMount() {
        var ctx = document.getElementById('myChart').getContext('2d');
        var chart = new Chart(ctx, {
            // The type of chart we want to create
            type: 'line',


            // The data for our dataset
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [{
                    label: 'My First dataset',
                    backgroundColor: 'rgb(255, 99, 132,0)',

                    borderColor: 'rgb(255, 99, 132)',
                    data: [0, 10, 5, 2, 20, 30, 45]
                }, {
                    label: 'My sec dataset',
                    backgroundColor: 'rgb(235, 99, 132,0)',

                    borderColor: 'rgb(115, 91, 132)',
                    data: [0, 5, 15, 13, 32, 43, 14]
                }]
            },

            // Configuration options go here
            options: {}
        });
        new Chart(ctx, { "type": "bar", "data": { "labels": ["January", "February", "March", "April", "May", "June", "July"], "datasets": [{ "label": "My First Dataset", "data": [65, 59, 80, 81, 56, 55, 40], "fill": false, "backgroundColor": ["rgba(255, 99, 132, 0.2)", "rgba(255, 159, 64, 0.2)", "rgba(255, 205, 86, 0.2)", "rgba(75, 192, 192, 0.2)", "rgba(54, 162, 235, 0.2)", "rgba(153, 102, 255, 0.2)", "rgba(201, 203, 207, 0.2)"], "borderColor": ["rgb(255, 99, 132)", "rgb(255, 159, 64)", "rgb(255, 205, 86)", "rgb(75, 192, 192)", "rgb(54, 162, 235)", "rgb(153, 102, 255)", "rgb(201, 203, 207)"], "borderWidth": 1 }] }, "options": { "scales": { "yAxes": [{ "ticks": { "beginAtZero": true } }] } } });
        // var myBarChart = new Chart(ctx, {
        //     type: 'bar',
        //     data: {
        //         data: [{ x: '2016-12-25', y: 20 }, { x: '2016-12-26', y: 10 }],
        //         datasets: [{
        //             barPercentage: 0.5,
        //             barThickness: 6,
        //             maxBarThickness: 8,
        //             minBarLength: 2,
        //             data: [10, 20, 30, 40, 50, 60, 70]
        //         }]
        //     },
        //     options: {
        //         scales: {
        //             xAxes: [{
        //                 gridLines: {
        //                     offsetGridLines: true
        //                 }
        //             }]
        //         }
        //     },
        // });

        new Chart(document.getElementById("pie-chart"), {
            type: 'doughnut',
            animationSteps: 10,
            data: {
                //   labels: ["Africa", "Asia", "Europe", "Latin America", "North America"],
                datasets: [{
                    label: "Population (millions)",
                    backgroundColor: ["#3e95cd", "#8e5ea2", "#3cba9f", "#e8c3b9", "#c45850"],
                    data: [99, 83, 55, 76, 89],
                }],
                labels: [
                    'Maths',
                    'Science',
                    'Hindi',
                    'English',
                    'IT'
                ],
            },
            options: {
                title: {
                    display: true,
                    text: 'Predicted world population (millions) in 2050'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>DashBoard</h2>
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <Card heading="Student" body="2560" icon="fa fa-user" />
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <Card heading="Parent" body="1560" icon="fa fa-user-md" />
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <Card heading="Teacher" body="20" icon="fa fa-users" />
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <Card heading="Total" body="2560" icon="fa fa-user" />
                    </div>

                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="card card-design-2 text-center">
                            <div className="card-header">
                                Featured
                                        </div>
                            <div className="card-body chart">
                                <canvas id="myChart"></canvas>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="card card-design-2 text-center">
                            <div className="card-header">
                                Featured
                                        </div>
                            <div className="card-body chart">
                                <canvas id="pie-chart" style={{ height: "300px", width: "300px" }}></canvas>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}
export default Dashboard;